// extracted by mini-css-extract-plugin
module.exports = {"text":"ErrorModal_text__A96Sq"};